const getIsPageVisible = state => {
    const { isLoggedIn, isSuperUser, isAdmin } = state.user;

    return !!(isLoggedIn && (isSuperUser || isAdmin));
};

export { getIsPageVisible };



// WEBPACK FOOTER //
// ./source/selectors/mainSelectors.js